"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_PROFILE = exports.USER_PROFILE = "user/USER_PROFILE";
var USER_PROFILE_SUCCESS = exports.USER_PROFILE_SUCCESS = "user/USER_PROFILE_SUCCESS";
var USER_PROFILE_FAILED = exports.USER_PROFILE_FAILED = "user/USER_PROFILE_FAILED";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/user/constants.ts
 ** module id = 646
 ** module chunks = 0
 **/